import { withInstall } from '../../../utils/with-install'
import ThreeLightPoint from './ThreeLightPoint.vue'

export const ElAmapThreeLightPoint = withInstall(ThreeLightPoint)
export default ElAmapThreeLightPoint
